import TabHandler from './TabHandler'
import FormShower from './FormShower'
import ScrollToTags from './ScrollToTags'
import MediaPassword from './MediaPassword'
import ScrollToForm from './ScrollToForm'

class Event {

  constructor() {
    const isEventPage = document.querySelector('.event')
    if (isEventPage) {
      const th = new TabHandler()
      const formShower = new FormShower()
      const mediaPassword = new MediaPassword()
      const scrollToForm = new ScrollToForm()
    }
    const scrollToTags = new ScrollToTags()
  }

}

export default Event